import { render, staticRenderFns } from "./AccountPlate.vue?vue&type=template&id=234cbc7d&"
import script from "./AccountPlate.vue?vue&type=script&lang=ts&"
export * from "./AccountPlate.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPlate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports